import { advanceOrFullPrice } from 'src/components/BookingFlow/ReservationEnd/functions/helperFunctions';
import { IPendingReservation } from './reservation';

export interface IService {
    Id: number;
    Name: string;
    Duration: number;
    DurationToUser: number;
    IsDurationVisible: boolean;
    HasArriveTime: boolean;
    HasQuestions: boolean;
}

export enum PaymentMethod {
    NotPayableOnline = 0,
    Advance = 1,
    FullPrice = 2
}

export interface IServiceDetails extends IService {
    Description: string | null;
    ShortDescription: string | null;
    Price: number | null;
    Currency: string | null;
    DisplayedPrice: string | null;
    DisplayedCurrency: string | null;
    PictureLink: string | null;
    Background: string;
    Note: string | null;
    PaymentMethod: PaymentMethod;
    VatPercentage: number | null;
    ItemName: string | null;
    Payable: boolean;
}

export interface IServiceIntervalRequest {
    serviceId: number;
    personCount: number;
    startDate: string;
    pendingReservations: IPendingReservation[];
    endDate?: string;
    modifiedReservationId?: number
}

export interface IServiceArriveTimeRequest {
    serviceId: number;
    startDate: string;
}

export interface IServicePriceData {
    Price: number | null;
    Currency: string | null;
    PaymentMethod: PaymentMethod;
    VatPercentage: number | null
    PersonCount?: number;
}

export interface IServiceSubtotal {
    Price: number | null;
    Currency: string | null;
}

export const fillPayableFields = (services: IServiceDetails[]) => {
    return services.map(fillPayableField);
}

export const fillPayableField = (service: IServiceDetails) => {
    service.Payable = isPayableService(service);
    return service;
}

export const isPayableService = (service: IServiceDetails) => {
    return advanceOrFullPrice(service.PaymentMethod) && service.VatPercentage !== null
        && service.ItemName !== null && service.Price !== null && service.Currency !== null;
}

export const calculateGrossPriceWithPersonCount = (data: IServicePriceData) => {
    const GrossPrice = calculateGrossPrice(data);
    return data.PersonCount ? GrossPrice * data.PersonCount : GrossPrice;
}

export const calculateGrossPrice = (data: IServicePriceData) => {
    if (data.Price && data.Currency) {
        const rawPrice = ((data.Price as number) * (1 + (data.VatPercentage as number)));

        return (
            advanceOrFullPrice(data.PaymentMethod) ?
                (data.Currency === 'EUR' ?
                    Math.round((rawPrice + Number.EPSILON) * 100) / 100
                    : Math.round(rawPrice))
                : 0
        )
    }
    return 0;
}

export const calculateSubtotal = (servicePriceData: IServicePriceData[]): IServiceSubtotal => {
    return {
        Price: servicePriceData.map((data) => calculateGrossPriceWithPersonCount(data)).reduce((sum, current) => sum + current, 0),
        Currency: servicePriceData[0].Currency
    }
}